module.exports = __webpack_public_path__ + "static/img/no-order.588f7f60.png";